/**
 * Enum for entity status values (active/inactive)
 * Used across the application for consistent entity status handling
 */
export enum EntityStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

/**
 * Type alias for entity status values
 * Use this for function parameters and return types
 */
export type EntityStatusType = EntityStatus;
